import batchHandleUrl from '../../../utils/url-handle.js'
const userApi = {
  // 用户列表
  userList: {
    url: '/apaas/person/getListByName',
    type: 'post',
    parameter: {
      name: String, // 用户真实姓名
      mobile: String, // 用户手机号
      organizationId: String, // 组织id
      status: Number, // 用户状态 0未激活 , 1已激活 ,2已停用
      page: Number, // 当前页
      pageSize: Number, // 每页条数 默认10条
      queryStatus: Number  // 0: 新建、编辑页面 展示的用户列表 1: 列表展示的用户列表
    }
  },
  // 获取单个人员信息
  getPersonById: {
    url: '/purchaser/person/getById',
    type: 'get'
  },
  supplierUserList: {
    url: '/apaas/supplier/list',
    type: 'post'
  },
  supplierGetById: {
    url: '/apaas/supplier/getById',
    type: 'get'
  },
  // 批量查询人员详情
  getInfoByIds: {
    url: '/apaas/object/value/user/getInfoByIds',
    type: 'post'
  }
}

export default batchHandleUrl(userApi)
